import {
  getAvailableLendersByLenderCommissions,
  getPreferredProduct
} from '__core/shared/util/salestrekker';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $mdUtil,
  webpage,
  cookies,
  authenticationService,
  eventService,
  dateTimeService,
  helperService,
  quickToolService,
  pdfService,
  helperPdfService,
  homeLoanFeesAndChargesPdfService,
  labelsService,
  organizationService,
  accountService,
  ticketService,
  ticketsService,
  contactsService,
  workflowService,
  assetFinanceService,
  homeLoanService,
  lendersService,
  LabelType,
  uiService
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    organizationCountry: helperService.getOrganizationCountry(),
    availableLabels: [],
    availableContactLabels: [],
    availableContacts: [],
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentTool: {},
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    availablePdfTypes: helperService.getAvailablePdfTypes(),
    isViewPdfPreparing: false,
    isSavePdfPreparing: false,
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
      });
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact(
        _.sortBy(contacts, (c) => _.indexOf($scope.Model.currentTicket?.idClients || [], c.id))
      );
      deferred.resolve($scope.Model.availableContacts);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadLenders = (account) => {
    const deferred = $q.defer();
    $scope.Model.isLenderReady = false;
    let lenderType = '';
    if ($scope.Model.currentWorkflow?.isHomeLoan()) {
      lenderType = 'RESIDENTIAL';
    } else if ($scope.Model.currentWorkflow?.isAssetFinance()) {
      lenderType = 'ASSET_FINANCE';
    } else if ($scope.Model.currentWorkflow?.isCommercialLoan()) {
      lenderType = 'COMMERCIAL';
    } else if ($scope.Model.currentWorkflow?.isPersonalLoan()) {
      lenderType = 'PERSONAL';
    }
    if (lenderType !== '') {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization?.id }),
        lendersService.getAvailable({
          cca2: [$scope.Model.organizationCountry?.cca2],
          type: lenderType
        }),
        $scope.Model.currentTicket?.idAssetFinance
          ? assetFinanceService.readAssetFinance({
              id: $scope.Model.currentTicket?.idAssetFinance,
              fields: {
                list: ['isCommercial']
              }
            })
          : {}
      ]).then((data) => {
        const organization = data[0];
        const lenders = data[1];
        const assetFinance = data[2];
        $scope.Model.allLenders = _.chain(lenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();

        const availableLenders = getAvailableLendersByLenderCommissions(
          lenders,
          organization,
          account,
          $scope.Model.currentWorkflow,
          $rootScope.IsEnterprise,
          assetFinance?.isCommercial || false
        );
        $scope.Model.availableLenders = _.chain(availableLenders)
          .sortNatural('name')
          .sortNatural('group')
          .value();

        $scope.Model.isLenderReady = true;
        deferred.resolve(lenders);
      });
    } else {
      $scope.Model.isLenderReady = true;
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const loadHomeLoan = (idHomeLoan) => {
    const deferred = $q.defer();
    homeLoanService.readHomeLoan({ id: idHomeLoan }).then((homeLoan) => {
      $scope.Model.currentTool = homeLoan;
      deferred.resolve(homeLoan);
    });
    return deferred.promise;
  };

  const loadAssetFinance = (idAssetFinance) => {
    const deferred = $q.defer();
    assetFinanceService.readAssetFinance({ id: idAssetFinance }).then((assetFinance) => {
      $scope.Model.currentTool = !assetFinance?.isCommercial ? assetFinance : {};
      deferred.resolve(!assetFinance?.isCommercial ? assetFinance : {});
    });
    return deferred.promise;
  };

  const redirect = () => {
    $state.transitionTo('deal', {
      id: $stateParams.id,
      dd: $stateParams.dd
    });
  };

  const initialize = () => {
    loadLabels();
    loadWorkflow();
    loadTicket($stateParams.dd).then(() => {
      webpage.pageTitle($scope.Model.currentTicket.getName());
      loadContacts($scope.Model.currentTicket.idClients).then(() => {
        loadAccount($scope.Model.currentTicket.idOwner).then(() => {
          loadLenders($scope.Model.currentTicketOwner).then(() => {
            if (
              $scope.Model.currentWorkflow.isAssetFinance() &&
              $scope.isLenderExistingInTicketOwnersLenderAccreditations() &&
              $scope.Model.currentTicket?.idAssetFinance
            ) {
              loadAssetFinance($scope.Model.currentTicket.idAssetFinance).then(() => {
                if (!_.isEmpty($scope.Model.currentTool)) {
                  $scope.Model.isReady = true;
                } else {
                  redirect();
                }
              });
            } else if (
              $scope.Model.currentWorkflow.isHomeLoan() &&
              $scope.isLenderExistingInTicketOwnersLenderAccreditations() &&
              $scope.Model.currentTicket?.idLoan
            ) {
              loadHomeLoan($scope.Model.currentTicket.idLoan).then(() => {
                $scope.Model.isReady = true;
              });
            } else {
              redirect();
            }
          });
        });
      });
    });
  };

  initialize();

  /*
   * Fees and charges ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.hasAssetFinanceTools = () =>
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentTicket.idAssetFinance &&
    $scope.Model.currentWorkflow.isAssetFinance() &&
    $rootScope.canSeeAssetFinanceTools();

  $scope.hasHomeLoanTools = () =>
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.currentTicket.idLoan &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.getAccount = (idAccount) =>
    _.find($scope.Model.availableAccounts, (a) => a?.id === idAccount);

  $scope.isLenderExistingInTicketOwnersLenderAccreditations = () => {
    const ticketOwner = $scope.getAccount($scope.Model.currentTicket.idOwner);
    let preferredProduct;
    if (ticketOwner?.lenderAccreditations?.length) {
      preferredProduct = getPreferredProduct(
        $scope.hasAssetFinanceTools()
          ? $scope.Model.currentTool?.compareProducts || []
          : $scope.Model.currentTool?.reviewProducts || []
      );
      if (preferredProduct) {
        let lender;
        if ($rootScope.IsEnterprise) {
          lender = _.find(
            $scope.Model.availableLenders || [],
            (l) =>
              l?.id ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        } else {
          lender = _.find(
            ticketOwner?.lenderAccreditations || [],
            (l) =>
              l?.idLender ===
              (preferredProduct?.selectedProduct?.lender[0]?.id || preferredProduct?.idLender)
          );
        }
        return lender !== undefined;
      }
      return true;
    }
    return true;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.hasPreferredProduct = () =>
    getPreferredProduct($scope.Model.currentTool.compareProducts || []) !== undefined;

  /*
   * Fees and charges ~ Compliance comments and documents
   * --------------------------------------------------------------------------------
   */
  $scope.saveFeesAndCharges = _.debounce((feesAndChanges) => {
    $scope.Model.currentTool.compliance.feesAndChanges = feesAndChanges;
    $scope.saveTool({ compliance: $scope.Model.currentTool.compliance });
  }, 500);

  /*
   * Fees and charges ~ Create PDF
   * --------------------------------------------------------------------------------
   */
  $scope.createPdf = ($event, isView) => {
    $event.stopPropagation();
    if (isView) {
      $scope.Model.isViewPdfPreparing = true;
    } else {
      $scope.Model.isSavePdfPreparing = true;
    }
    pdfService
      .createPdf({
        contacts: $scope.Model.availableContacts,
        contactLabels: $scope.Model.availableContactLabels,
        ticket: $scope.Model.currentTicket,
        ticketOwner: $scope.Model.currentTicketOwner,
        loan: $scope.Model.currentTool,
        pdfType: $scope.Model.availablePdfTypes[6],
        isView
      })
      .then(() => {
        $scope.Model.isViewPdfPreparing = false;
        $scope.Model.isSavePdfPreparing = false;
      });
  };

  /*
   * Fees and charges ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Fees and charges ~ Save Tool
   * --------------------------------------------------------------------------------
   */
  $scope.saveTool = (data) => {
    if (
      !$scope.Model.currentTicket?.isSettled &&
      $scope.Model.currentTool.id &&
      ($scope.hasAssetFinanceTools() || $scope.hasHomeLoanTools())
    ) {
      const isAssetFinance = $scope.hasAssetFinanceTools();
      const payload = data;
      $scope.Model.currentTool.deleteDateObject();
      payload.id = $scope.Model.currentTool.id;
      const handler = isAssetFinance
        ? assetFinanceService.updateAssetFinancePartial(payload)
        : homeLoanService.updateHomeLoanPartial(payload);
      handler.then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: isAssetFinance ? 'Asset finance for deal' : 'Home loan for deal',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'has been updated'
            },
            success: true
          });
        }
      });
    }
  };
};
